<template>
  <div class="empty-content-wrap">
    <img v-if="data.img" :src="data.img" alt="" class="img-wrap" />
    <h3 class="title" v-if="data.title">{{ data.title }}</h3>
    <div class="desc" v-if="data.desc">{{ data.desc }}</div>
    <div class="btn-box">
      <template v-for="(item, index) in data.buttons">
        <el-button class="btn" @click="item.click" :type="item.type ? item.type : 'primary'" :key="index" v-if="!item.auth || authPromise(item.auth)">
          {{ item.text }}
        </el-button>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'emptyCard',
  computed: {},
  props: {
    data: {
      default: {
        img: '',
        title: '默认',
        desc: '默认',
        buttons: []
      }
    }
  }
}
</script>
<style lang="scss">
.empty-content-wrap {
  display: flex;
  background: #fff;
  padding: 120px 0;
  border-radius: 5px;
  height: 100%;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  .title {
    margin: 16px;
    color: $--text-26;
    font-size: 16px;
  }
  .img-wrap {
    width: 240px;
  }
  .desc {
    margin: 14px;
    color: $--text-99;
    font-size: 14px;
  }
  .btn-box {
    margin-top: 20px;
    .btn {
      margin-right: 12px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
